// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"7860ca83","49":"1890db3b","187":"f15d8e2d","246":"1104ebef","391":"06e614a6","457":"1c8db973","685":"bea55232","749":"74119ef3","787":"8345db89"}[chunkId] + ".chunk.js";
};